
















































































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Emit, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../Mixins/ModelSetter'
import { errorNotificationWrapper, warningNotificationWrapper } from '../../../logic/helpers/NotificationService'
import MultiCurrencyInput from '../../CurrensyInput/MultiCurrencyInput.vue'
import { UseFields } from '../../Pi'
import { FieldData } from '../../Pi/types'
import { currencies } from '../Currencies'
import CurrenciesHelperMixin from "../CurrenciesHelperMixin";
import {
  CreateProductModel,
  Product,
  ProductType,
} from './types'

@Component({
  data() {
    return {
      isMobile,
      currencies
    }
  },
  components: {
    MultiCurrencyInput,
  }
})
export default class CreateNewProduct extends Mixins(ModelSetter, UseFields, CurrenciesHelperMixin) {
  @VModel() isOpen!: boolean

  @Prop() createProduct!: (product: CreateProductModel) => Promise<Product>

  @Prop() initialName!: string

  @Prop() targetId!: string

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    this.imgTemplate += 1
    if (val) {
      this.newProduct.name = this.initialName
    }
  }

  get context(): this {
    return this
  }

  creating = false

  imgTemplate = 0

  newProduct: CreateProductModel = {
    name: '',
    description: '',
    type: ProductType.Service,
    image: '',
    cost: 0,
    currency: this.$i18n.locale === 'ru' ? 'RUB' : 'USD',
  }

  setPrice(arg: FieldData): FieldData {
    arg.setter = ({ cost, currency }) => {
      this.newProduct.cost = cost
      this.newProduct.currency = currency
    }
    return arg
  }

  okHandler(): void {
    const validName = this.newProduct.name.trim().length > 0
    const validDescription = this.newProduct.description.trim().length > 0

    if (validName && validDescription) {
      this.creating = true

      this.createProduct(this.newProduct)
        .then((product) => this.inputProduct(product))
        .finally(() => {
          this.creating = false
          this.isOpen = false
        })
        .catch((e) => {
          this.creating = false
          errorNotificationWrapper(this.$t('error').toString(), e)
        })
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())
    }
  }

  cancelHandler(): void {
    this.newProduct = {
      name: '',
      description: '',
      type: ProductType.Service,
      image: '',
      cost: 0,
      currency: this.$i18n.locale === 'ru' ? 'RUB' : 'USD',
    }
  }

  @Emit()
  inputProduct(product: Product): Product {
    return product
  }
}
